import React, { useState, useEffect } from 'react';
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';
import { FaUsers, FaSignOutAlt, FaCogs, FaUser, FaBuilding, FaHotel } from 'react-icons/fa';
import { FaClipboardList } from 'react-icons/fa';

const roles = JSON.parse(localStorage.getItem('userRoles')) || [];

const puedeVerUsuarios = roles.includes('Administrador_USUARIOS') || roles.includes('Admin');
const esRecepcionista = roles.includes('Recepcionista_EBRO') || roles.includes('Recepcionista_RADISSON');

const hasEbro = roles.includes('Recepcionista_EBRO');
const hasBlu  = roles.includes('Recepcionista_RADISSON');
const canSwitchUnit = hasEbro && hasBlu;

function NavScrollExample() {
  const email = localStorage.getItem('email');
  const [gradientClass, setGradientClass] = useState('Blu'); // Blu | Hebro

  const gradients = {
    Blu: 'linear-gradient(135deg, #0d47a1, #1a237e)',
    Hebro: 'linear-gradient(135deg, #6c757d, #495057)',
  };

  const businessUnits = {
    Blu:   { name: 'Radisson Blu', icon: <FaHotel className="me-2" /> },
    Hebro: { name: 'PEBEBRO',      icon: <FaBuilding className="me-2" /> }
  };

  // Enforce unidad según roles y/o valor guardado
  useEffect(() => {
    const saved = localStorage.getItem('businessUnit'); // 'CHLPBCH' | 'PEBEBRO'
    if (canSwitchUnit) {
      if (saved === 'PEBEBRO') setGradientClass('Hebro');
      else if (saved === 'CHLPBCH') setGradientClass('Blu');
      else {
        localStorage.setItem('businessUnit', 'PEBEBRO');
        setGradientClass('Hebro');
      }
    } else if (hasEbro) {
      if (saved !== 'PEBEBRO') localStorage.setItem('businessUnit', 'PEBEBRO');
      setGradientClass('Hebro');
    } else if (hasBlu) {
      if (saved !== 'CHLPBCH') localStorage.setItem('businessUnit', 'CHLPBCH');
      setGradientClass('Blu');
    } else {
      // Sin roles de recepcionista: fallback a CHLPBCH/Blu
      if (saved !== 'CHLPBCH') localStorage.setItem('businessUnit', '');
      setGradientClass('Blu');
    }
  }, []);

  const handleBusinessUnitChange = (unit) => {
    if (!canSwitchUnit) return; // 🔒 Bloquear cambio si no tiene ambos roles
    if (unit === 'Hebro') {
      setGradientClass('Hebro');
      localStorage.setItem('businessUnit', 'PEBEBRO');
    } else {
      setGradientClass('Blu');
      localStorage.setItem('businessUnit', 'CHLPBCH');
    }
    // Si quieres forzar relectura global de config:
    // window.location.reload();
  };

  const fixedUnitKey  = hasEbro ? 'Hebro' : 'Blu';
  const fixedUnitIcon = businessUnits[fixedUnitKey].icon;
  const fixedUnitName = businessUnits[fixedUnitKey].name;

  return (
    <Navbar
      collapseOnSelect
      expand="lg"
      variant="dark"
      style={{
        background: gradients[gradientClass],
        boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
        padding: '0.5rem 0'
      }}
    >
      <Container fluid className="px-4">
        <Navbar.Brand href="#" className="d-flex align-items-center">
          <span className="fs-4 fw-bold" style={{ letterSpacing: '1px' }}>
            {businessUnits[gradientClass].icon}
            {businessUnits[gradientClass].name} Admin
          </span>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="responsive-navbar-nav" />

        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto align-items-center">
            {puedeVerUsuarios && (
              <Nav.Link href="#/users" className="mx-2 d-flex align-items-center">
                <FaUsers className="me-1" /> Usuarios
              </Nav.Link>
            )}

            {puedeVerUsuarios && (
              <Nav.Link href="#/auditoria" className="mx-2 d-flex align-items-center">
                <FaClipboardList className="me-1" /> Auditoría
              </Nav.Link>
            )}

            <NavDropdown
              title={
                <span className=" align-items-center">
                  <FaCogs className="me-1" /> Funciones
                </span>
              }
              id="functions-dropdown"
              className="mx-2"
            >
              {esRecepcionista && (
                <NavDropdown.Item href="#/validarCheckInExpress" className="d-flex align-items-center">
                  <FaCogs className="me-2" /> Validar Check-in
                </NavDropdown.Item>
              )}
            </NavDropdown>

            {canSwitchUnit ? (
              <NavDropdown
                title={
                  <span className=" align-items-center">
                    <FaBuilding className="me-1" /> Unidad
                  </span>
                }
                id="business-unit-dropdown"
                className="mx-2"
              >
                <NavDropdown.Item
                  onClick={() => handleBusinessUnitChange('Hebro')}
                  className="d-flex align-items-center"
                  active={gradientClass === 'Hebro'}
                >
                  <FaBuilding className="me-2" /> PEBEBRO
                </NavDropdown.Item>

                <NavDropdown.Item
                  onClick={() => handleBusinessUnitChange('Blu')}
                  className="d-flex align-items-center"
                  active={gradientClass === 'Blu'}
                >
                  <FaHotel className="me-2" /> Radisson Blu
                </NavDropdown.Item>
              </NavDropdown>
            ) : (
              <NavDropdown
                title={
                  <span className=" align-items-center">
                    <FaBuilding className="me-1" /> Unidad
                  </span>
                }
                id="business-unit-dropdown"
                className="mx-2"
                disabled
              >
                <NavDropdown.Item active className="d-flex align-items-center">
                  {fixedUnitIcon} {fixedUnitName}
                </NavDropdown.Item>
              </NavDropdown>
            )}
          </Nav>

          <Nav className="ms-auto align-items-center">
            <NavDropdown
              title={
                <span className=" align-items-center">
                  <FaUser className="me-2" />
                  <span className="d-none d-lg-inline">
                    {email?.split('@')[0] || 'Usuario'}
                  </span>
                </span>
              }
              align="end"
              id="user-dropdown"
            >
              <NavDropdown.Item href="#/profile" className="d-flex align-items-center">
                <FaUser className="me-2" /> Mi Perfil
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="/#/Logout" className="d-flex align-items-center">
                <FaSignOutAlt className="me-2" /> Cerrar Sesión
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavScrollExample;
